import { AboutPage } from ".";
import { getAboutPageData } from "../../calls/get/AboutPage";
import { getPostList } from "../../calls/get/postList";
import { getReplicatorsPage } from "../../calls/get/ReplicatorsPage";
import { getSisterProjectsPage } from "../../calls/get/SisterProjectsPage";
import { ROUTES } from "../../config/menuRoutes";
import { FetchErrorPage } from "../FetchError";

export const aboutPageRoute = {
  path: ROUTES.ABOUT,
  element: <AboutPage />,
  errorElement: <FetchErrorPage />,
  loader: async ({ params }) => ({
    params,
    page: await getAboutPageData(),
    postList: await getPostList(),
  }),
};

export const sisterProjectsPageRoute = {
  path: ROUTES.SISTER_PROJECTS,
  element: <AboutPage />,
  errorElement: <FetchErrorPage />,
  loader: async ({ params }) => ({
    params,
    page: await getSisterProjectsPage(),
    postList: await getPostList(),
  }),
};
export const replicatorsPagePageRoute = {
  path: ROUTES.REPLICATORS,
  element: <AboutPage />,
  errorElement: <FetchErrorPage />,
  loader: async ({ params }) => ({
    params,
    page: await getReplicatorsPage(),
    postList: await getPostList(),
  }),
};
